import { colors } from './colors';

/**
 * Accent identities for charts and metric surfaces.
 *
 * These used to live on AccentCard, which painted them as a coloured edge
 * stripe along the top or left of a card. The design system retired that
 * pattern — importance is carried by a teal border and halo, never by a
 * coloured edge — so the vocabulary survives here as pure colour identity for
 * chart series, sparklines and hover glows.
 */

export type AccentColor = 'cyan' | 'purple' | 'green' | 'amber' | 'error';

export const accentColors: Record<AccentColor, string> = {
  cyan: colors.primary.neon,
  purple: colors.accent.purple[500],
  green: colors.status.success.main,
  amber: colors.status.warning.main,
  error: colors.status.error.main,
};

export const accentGlows: Record<AccentColor, string> = {
  cyan: colors.glow.cyan,
  purple: colors.glow.purple,
  green: colors.glow.green,
  amber: colors.glow.amber,
  error: colors.glow.error,
};
